module.exports = __webpack_public_path__ + "static/media/satori.4c78cf5f.webp";